import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const CardBase = styled.div<{ $unavailable?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  padding: ${space[4]};
  background: ${colors.white};
  border: 1px solid ${semantic.border.subtle};
  border-radius: ${layout.borderRadiusLg};
  opacity: ${({ $unavailable }) => ($unavailable ? 0.55 : 1)};
`;

export const TopRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  gap: ${space[3]};
`;

export const TimePill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 9999px;
  background: ${semantic.bg.surfaceSubtle};
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;

export const MiddleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
  min-width: 0;
`;

export const Title = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Meta = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const Price = styled.div`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
`;

export const SpotsLeft = styled.span<{ $low: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${space[2]};
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $low }) => ($low ? semantic.bg.urgencyStrong : semantic.bg.positiveStrong)};
  }
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  height: 40px;
  padding: 0 ${space[4]};
  border: none;
  border-radius: 9999px;
  background: ${colors.primary};
  color: ${colors.white};
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;
